import { Component } from '@angular/core';
import { Skeleton } from 'primeng/skeleton';

@Component({
  selector: 'app-activity-skeleton',
  imports: [Skeleton],
  templateUrl: './activity-skeleton.component.html',
  styleUrl: './activity-skeleton.component.scss',
})
export class ActivitySkeletonComponent {}
